import { gql } from '@apollo/client';

export const DELETE_ABSCHNITT = gql`
  mutation mitarbeiter_deleteAbschnitt(
    $abschnittId: String!
    $rotationsplanId: String!
    $position: Int!
  ) {
    mitarbeiter_deleteAbschnitt(
      abschnittId: $abschnittId,
      rotationsplanId: $rotationsplanId,
      position: $position
    ) {
      success {
        abschnittId
        details
      }
      error {
        message
      }
    }
  }
`;
